import { render, staticRenderFns } from "./ReviewScore.vue?vue&type=template&id=43970bf2&"
import script from "./ReviewScore.vue?vue&type=script&lang=js&"
export * from "./ReviewScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports